import React, { useState } from "react";
import { injectIntl } from "react-intl";
import {
  backendShape,
  List,
  isNotEmpty,
  Loader,
  intlShape,
  Row,
  Column,
  notifierShape,
  withBackend,
  withAccessRights,
  accessRightsShape,
  withNotifier,
} from "lcm-iot-commons";
import OpcUaServerCertificateItem from "./OpcUaServerCertificateItem";
import { opcUaServerShape } from "../../shapes/opcUaServersShape";

type OwnProps = {
  intl: intlShape;
  type?: "ca" | "client";
  opcUaServer: opcUaServerShape;
  accessRights: accessRightsShape;
  notifier: notifierShape;
  backend: backendShape;
};

const defaultProps: Partial<OwnProps> = {
  type: "client",
};

type Props = OwnProps & typeof defaultProps;

export function OpcUaServerCertificatesList({
  intl,
  opcUaServer,
  notifier,
  accessRights,
  backend,
  type,
}: Props) {
  const [certificates, setCertificates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadCertificates = async () => {
    try {
      const certificatesResponse = await backend.getAll(
        `/api_subscriptions/${opcUaServer.subscription_id}/opc_ua_servers/${opcUaServer.id}/${type}_certificates`,
      );
      // eslint-disable-next-line camelcase
      const certificatesData =
        certificatesResponse[`${type}_certificates`]?.length > 0
          ? certificatesResponse[`${type}_certificates`]
          : [];
      setCertificates(certificatesData);
    } catch (error) {
      notifier.showError(backend.translateError(error));
    }
    setIsLoading(false);
  };

  React.useEffect(() => {
    loadCertificates();
  }, [opcUaServer]);

  const handleOnCertificateRemoved = (certificate: $TSFixMe) => {
    setCertificates(
      certificates.filter((i) => (i as $TSFixMe).id !== certificate.id),
    );
  };

  const handleOnCertificateStatusChanged = () => {
    setIsLoading(false);
    loadCertificates();
  };

  const renderItems = (items: $TSFixMe) => (
    <ul id={`${type}-certificate-item-list`} className="list">
      {items.map((item: $TSFixMe) => (
        <OpcUaServerCertificateItem
          key={item.id}
          onCertificateRemoved={handleOnCertificateRemoved}
          onCertificateStatusChanged={handleOnCertificateStatusChanged}
          type={type}
          accessRights={accessRights}
          opcUaServer={opcUaServer}
          certificate={item}
        />
      ))}
    </ul>
  );

  const showEmptyMessage = () =>
    !isLoading ? (
      <p id="empty-message" className="space-after">
        {intl.formatMessage({
          id: `opc_ua_server_details.no_${type}_certificates`,
        })}
      </p>
    ) : (
      <p />
    );

  return (
    <Loader loading={isLoading}>
      <Row>
        <Column>
          <List id={`assigned-${type}-certificates-list`}>
            {isNotEmpty(certificates)
              ? renderItems(certificates)
              : showEmptyMessage()}
          </List>
        </Column>
      </Row>
    </Loader>
  );
}

OpcUaServerCertificatesList.defaultProps = defaultProps;

export default injectIntl(
  // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
  withNotifier(withBackend(withAccessRights(OpcUaServerCertificatesList))),
);
